import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StopsService } from '../../services/requests/stops.service';
import { GlobalService } from '../../services/global.service';
import { UsersService } from '../../services/requests/users.service';

@Component({
  selector: 'app-stops',
  templateUrl: './stops.component.html',
  styleUrls: ['./stops.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class StopsComponent implements OnInit {
  loading = true; // Ajout de la propriété loading
  stops: any[] = [];
  sort = {
    limit: 50,
    offset: 0,
    total: 100
  };
  idClient = "";
  filtreClient: string = '';
  isAdmin = false;
  isSousAdmin = false;
  clients: any[] = [];
  filteredClients: any[] = [];
  campagnes: any[] = [];
  idCampagne = "";
  sortField: string = 'client';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private route: ActivatedRoute,
    private stopsService: StopsService,
    private globalService: GlobalService,
    private usersService: UsersService
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem("isAdmin") === "true") this.isAdmin = true;
    if (localStorage.getItem("isSousAdmin") === "true") this.isSousAdmin = true;
    
    // Récupérer le tri sauvegardé depuis localStorage
    const savedSort = localStorage.getItem('stopsSort');
    if (savedSort) {
      try {
        const sortData = JSON.parse(savedSort);
        this.sortField = sortData.field || 'client';
        this.sortDirection = sortData.direction || 'asc';
      } catch (e) {
        console.error('Erreur lors de la récupération du tri:', e);
      }
    }
    
    this.getClients();
  }
  
  toggleSort(field: string): void {
    if (this.sortField === field) {
      // Si on clique sur la même colonne, inverser la direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Si on clique sur une nouvelle colonne, trier par ordre croissant
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    
    // Sauvegarder le tri dans localStorage
    try {
      localStorage.setItem('stopsSort', JSON.stringify({
        field: this.sortField,
        direction: this.sortDirection
      }));
    } catch (e) {
      console.error('Erreur lors de la sauvegarde du tri:', e);
    }
    
    this.applySort();
  }
  
  applySort(): void {
    let clientsToSort = [...this.clients];
    
    // Appliquer le filtre si nécessaire
    if (this.filtreClient.trim()) {
      const lower = this.filtreClient.toLowerCase();
      clientsToSort = clientsToSort.filter(c =>
        c.identifiant?.toLowerCase().includes(lower)
      );
    }
    
    // Appliquer le tri
    this.filteredClients = clientsToSort.sort((a, b) => {
      let valueA: any;
      let valueB: any;
      
      switch (this.sortField) {
        case 'client':
          valueA = a.identifiant?.toLowerCase() || '';
          valueB = b.identifiant?.toLowerCase() || '';
          return this.sortDirection === 'asc' 
            ? valueA.localeCompare(valueB) 
            : valueB.localeCompare(valueA);
        
        case 'reponses':
          valueA = a.totalStop || 0;
          valueB = b.totalStop || 0;
          return this.sortDirection === 'asc' 
            ? valueA - valueB 
            : valueB - valueA;
        
        case 'stop':
          valueA = a.totalFailed || 0;
          valueB = b.totalFailed || 0;
          return this.sortDirection === 'asc' 
            ? valueA - valueB 
            : valueB - valueA;
        
        default:
          return 0;
      }
    });
  }

  getClients(): void {
    this.loading = true; // Démarre le loading
    
    this.usersService.getAll().subscribe({
      next: (res: any) => {
        if (res.status && res.data?.users) {
          this.clients = res.data.users.filter((u: any) => u.typeAccount === 'client' || u.typeAccount === 'smpp');
          for (let c of this.clients) {
            this.getStops(c._id);
          }
          this.applySort();
        }
        this.loading = false; // Arrête le loading
      },
      error: (err: any) => {
        console.error("❌ Erreur getClients() dans stops.component :", err);
        this.loading = false; // Arrête le loading même en cas d'erreur
      }
    });
  }

  getStops(idClient: string): void {
    this.globalService.post('/SP-GetNombreStops', {
      idClient,
      limit: this.sort.limit,
      offset: this.sort.offset
    }).subscribe(
      (response: any) => {
        if (response.status) {
          const client = this.clients.find(c => c._id === idClient);
          if (client) {
            client.totalStop = response.totalStop;
            client.totalFailed = response.totalFailed;
            this.applySort();
          }
        }
      },
      () => {}
    );
  }

  exporterNouveauxStops(idClient: string): void {
    this.stopsService.exportNewStops({ idClient }).subscribe(
      (response: any) => {
        if (response.status && response.data?.url) {
          window.location.href = response.data.url;
          this.getStops(idClient);
        } else {
          alert('Erreur lors de l\'export.');
        }
      },
      () => {
        alert('Erreur lors de l\'export.');
      }
    );
  }

  exporterTousStops(idClient: string): void {
    this.stopsService.exportAllStops({ idClient }).subscribe(
      (response: any) => {
        if (response.status && response.data?.url) {
          window.location.href = response.data.url;
        } else {
          alert('Erreur lors de l\'export.');
        }
      },
      () => {
        alert('Erreur lors de l\'export.');
      }
    );
  }

  exporterReponses(idClient: string): void {
    this.stopsService.exportReponses({ idClient }).subscribe(
      (response: any) => {
        if (response.status && response.data?.url) {
          window.location.href = response.data.url;
        } else {
          alert('Erreur lors de l\'export.');
        }
      },
      () => {
        alert('Erreur lors de l\'export.');
      }
    );
  }

  onFilterChange(): void {
    this.applySort();
  }
}
